// This rounds to the nearest 0.5
export const parseScore = (str) => Math.round( parseFloat(str) * 2 ) / 2;

